// Outspoken Ebikes Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for anchor links
  initSmoothScroll();
  
  // Initialize animations on scroll
  initScrollAnimations();
  
  // Initialize product quantity controls
  initQuantityControls();
});

// Smooth scroll for internal links
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
}

// Scroll animations
function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-up');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe elements with animation class
  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
}

// Product quantity controls
function initQuantityControls() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const minusBtn = selector.querySelector('.quantity-minus');
    const plusBtn = selector.querySelector('.quantity-plus');
    const input = selector.querySelector('.quantity-input');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', function() {
        const current = parseInt(input.value) || 1;
        if (current > 1) {
          input.value = current - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn.addEventListener('click', function() {
        const current = parseInt(input.value) || 1;
        const max = parseInt(input.getAttribute('max')) || 999;
        if (current < max) {
          input.value = current + 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }
  });
}

// Add to cart functionality
function addToCart(formData) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Error adding to cart:', error);
    throw error;
  });
}

// Update cart
function updateCart(updates) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Error updating cart:', error);
    throw error;
  });
}

// Show notification
function showNotification(message, type = 'success') {
  const notification = document.createElement('div');
  notification.className = `notification notification-${type}`;
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    top: 100px;
    right: 20px;
    padding: 1rem 1.5rem;
    background: ${type === 'success' ? 'linear-gradient(to right, #f97316, #ef4444)' : '#ef4444'};
    color: white;
    border-radius: 0.5rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    animation: slideInRight 0.3s ease-out;
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.animation = 'fadeOut 0.3s ease-out';
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 300);
  }, 3000);
}

// Handle product form submission
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('product-form')) {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    const data = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity')) || 1
    };

    const submitBtn = e.target.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    addToCart(data)
      .then(() => {
        showNotification('Product added to cart!', 'success');
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        // Update cart count if needed
        updateCartCount();
      })
      .catch(error => {
        showNotification('Failed to add product to cart', 'error');
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      });
  }
});

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.style.display = 'inline-block';
        }
      });
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Initialize cart count on page load
updateCartCount();

// Handle image zoom on product pages
document.querySelectorAll('.product-image-zoom').forEach(img => {
  img.addEventListener('click', function() {
    // Create modal for zoomed image
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      cursor: zoom-out;
    `;
    
    const zoomedImg = document.createElement('img');
    zoomedImg.src = this.src.replace(/_(small|medium|large|compact|grande)/, '');
    zoomedImg.style.cssText = `
      max-width: 90%;
      max-height: 90%;
      object-fit: contain;
    `;
    
    modal.appendChild(zoomedImg);
    document.body.appendChild(modal);
    
    modal.addEventListener('click', function() {
      document.body.removeChild(modal);
    });
  });
});

// Lazy loading for images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        imageObserver.unobserve(img);
      }
    });
  });

  document.querySelectorAll('img.lazy').forEach(img => {
    imageObserver.observe(img);
  });
}
